// TableOrdenServicioTraslado.tsx

import { GeneralTable } from "@/shared/components/ui";
import { ROUTER_PATHS, TABLE_CONSTANTS_COLUMS, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useTableColumnsOrdenServicioTraslado } from "../../hooks";
import { useFetchAgendamientos } from "@/shared/actions/erp";
import { Grid, IconButton } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Agendamiento } from "@/shared/interfaces";

type TableOrdenServicioTrasladoProps = {
  estadoAgendamiento: string
}
export default function TableOrdenServicioTraslado({
  estadoAgendamiento
}: TableOrdenServicioTrasladoProps) {

  const returnUrlAgendamientosPyLPage =
    ROUTER_PATHS.operaciones.trasladosAgendamientoPyLNav;

  const navigate = useNavigate();

  // hook
  const {
    pagination,
    setPagination
  } = useTableFilter();

  const {
    pageIndex,
    pageSize
  } = pagination;

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();

  const {
    columns
  } = useTableColumnsOrdenServicioTraslado()

  // fetch
  /* const {
    isLoading,
    data,
    isRefetching
  } = useFetchGetOrdenServicioTraslado({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      ...filterObject,
      filterByState: false
    }
  }); */

  const {
    data,
    isLoading,
    isRefetching,
  } = useFetchAgendamientos({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      ...filterObject,
      filterByState: false,
      estado_agendamiento_in: estadoAgendamiento,
      tipo_orden_servicio: 'TRASLADO'
    },
  });

  const onEdit = (value: Agendamiento) => {
    navigate(
      `${returnUrlAgendamientosPyLPage}/${value.id_agendamiento}`
    );
  }

  return <>
    <GeneralTable<Agendamiento>
      columns={columns}
      data={data?.data?.data || []}
      isLoading={isLoading}
      isRefetching={isRefetching}
      // // filters - server side
      enableManualFiltering={true}
      columnFilters={columnFilters}
      onColumnFiltersChange={setColumnFilters}
      // // search
      enableGlobalFilter={false}
      // // pagination
      pagination={pagination}
      onPaging={setPagination}
      rowCount={data?.data?.count}
      // // // actions ========
      enableColumnActions={true}
      enableEditing={true}
      canEdit={false}
      // crud
      showCustomActionBtnSpace={true}
      actionsColumnSize={TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL}
      customActionBtnSpace={(row) => {

        return (
          <Grid container>
            <Grid item>

              <IconButton
                onClick={() => onEdit(row)}
              >
                <Edit />
              </IconButton>
            </Grid>
          </Grid>
        )
      }}


    />

  </>
}
